import { useState, useEffect, useCallback } from 'react';

export const useStaticQuery = (dataFetcher) => {
  const [state, setState] = useState({
    data: null,
    isLoading: true,
    isError: false,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;
    try {
      const data = dataFetcher();
      if (!cancelled) {
        setState({ data, isLoading: false, isError: false, error: null });
      }
    } catch (err) {
      if (!cancelled) {
        setState({ data: null, isLoading: false, isError: true, error: err });
      }
    }
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refetch = useCallback(() => {
    let cancelled = false;
    try {
      const data = dataFetcher();
      if (!cancelled) {
        setState({ data, isLoading: false, isError: false, error: null });
      }
      return Promise.resolve(data);
    } catch (err) {
      if (!cancelled) {
        setState({ data: null, isLoading: false, isError: true, error: err });
      }
      return Promise.reject(err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { ...state, refetch };
};

export const useStaticMutation = () => {
  const [state, setState] = useState({
    data: null,
    error: null,
    isError: false,
    isSuccess: false,
    isLoading: false,
  });

  const trigger = useCallback(async (payload) => {
    setState({ data: null, error: null, isError: false, isSuccess: false, isLoading: true });

    await new Promise(resolve => setTimeout(resolve, 200));

    const response = {
      data: {
        message: 'Operation recorded (static mode)',
        ...payload,
      },
    };

    setState({
      data: response.data,
      error: null,
      isError: false,
      isSuccess: true,
      isLoading: false,
    });

    return response;
  }, []);

  return [trigger, state];
};
